<template>
  <v-autocomplete
      v-model="value"
      :items="values"
      item-text="string"

      :label="label"
      :disabled="disabled"
      :clearable="clearable"
      return-object
      hide-details
  />
</template>

<script>
import VueTypes from "vue-types";
import {ItemKey} from "@/modules/redactor/models/item/core/ItemKey";
import {RedactorUtils} from "@/modules/redactor/core/RedactorUtils";

export default {
  name: "r-item-dropdown",
  props: {
    label: VueTypes.string.def("Item"),
    model: VueTypes.instanceOf(ItemKey),
    disabled: VueTypes.bool.def(false),
    clearable: VueTypes.bool.def(true)
  },
  data: () => ({
    values: []
  }),
  computed: {
    value: {
      get: function () {
        return this.model;
      },
      set: function (value) {
        this.$emit("update:model", value);
      }
    }
  },
  created() {
    this.values = RedactorUtils.getItems().map(v => {
      return v.key;
    });
  }
}
</script>
